document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-load-ghl]');
  if (!trigger) return;
  const host = trigger.closest('[data-ghl-form]');
  const template = host.querySelector('template');
  host.replaceChildren(template.content.cloneNode(true));
  if (!document.querySelector('script[data-ghl-embed]')) {
    const script = document.createElement('script');
    script.src = 'https://hub.dropshipvending.com/js/form_embed.js';
    script.dataset.ghlEmbed = '';
    document.body.append(script);
  }
});
document.addEventListener('load', (event) => {
  if (!(event.target instanceof HTMLIFrameElement) || !event.target.closest('[data-ghl-form]')) return;
  event.target.closest('[data-ghl-form]')?.querySelector('[data-ghl-loading]')?.remove();
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = document.activeElement.closest('details[open]');
  if (open) { open.open = false; open.querySelector('summary').focus(); }
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-option-value]')) return;
  const form = event.target.closest('form');
  const picker = event.target.closest('[data-variant-picker]');
  const variants = JSON.parse(picker.querySelector('[data-product-variants]').textContent);
  const values = [...picker.querySelectorAll('[data-option-group]')].map(group => group.querySelector('[data-option-value]:checked')?.value);
  const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
  if (!variant) return;
  picker.querySelector('[data-variant-id]').value = variant.id;
  form.querySelector('[data-variant-price]').textContent = variant.price;
  const button = form.querySelector('[data-add-to-cart]');
  button.disabled = !variant.available;
  button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
  const quantity = form.querySelector('[name="quantity"]');
  quantity.min = variant.min;
  quantity.step = variant.step;
  quantity.value = variant.min;
  if (variant.max) quantity.max = variant.max;
  else quantity.removeAttribute('max');
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  history.replaceState({}, '', url);
  const gallery = event.target.closest('.product-layout')?.querySelector('[data-gallery]');
  gallery?.dispatchEvent(new CustomEvent('variant:media', { detail: variant.mediaId }));
});
